module.exports = __webpack_public_path__ + "img/check_member_icon.8cc7a291.png";